import * as React from 'react';
import { DateTime } from 'ui';
import { parseAsDateUTC, createUTCDate, dateToUTC, createFormatters } from 'app/infrastructure/data/date';
import { FilterCommonProps, OptionType, SubOptionType } from './types';
import { getValue } from './get-value';

import styles from './filter-date-range.scss';
import { MeatballPanel } from 'app/area/search-filters/filters/meatball-panel';

export class FilterDateSpecificPeriod extends React.PureComponent<FilterCommonProps<Date>> {
  private onChangeDate = (value: Date, subOptionType: SubOptionType) => {
    const { values } = this.props;

    this.props.onChange(this.props.id, [{
      optionType: OptionType.specified,
      subOptionType: SubOptionType.dateFrom,
      value: subOptionType === SubOptionType.dateFrom ? value : getValue(values, SubOptionType.dateFrom).value
    }, {
      optionType: OptionType.specified,
      subOptionType: SubOptionType.dateTo,
      value: subOptionType === SubOptionType.dateTo ? value : getValue(values, SubOptionType.dateTo).value
    }].filter(v => !!v.value) || []);
  };

  private onChangeDateFrom = (value: Date) => this.onChangeDate(value, SubOptionType.dateFrom);
  private onChangeDateTo = (value: Date) => this.onChangeDate(value, SubOptionType.dateTo);

  public render() {
    const { id, values, translation, locale, meatballPanelConfiguration } = this.props;

    const dateFrom = getValue(values, SubOptionType.dateFrom);
    const dateTo = getValue(values, SubOptionType.dateTo);

    return <div className="form-check">
      <MeatballPanel configuration={meatballPanelConfiguration} />
      <div className={styles.dateGroup}>
        <div>
          <label>{translation.filters_date_range_from}</label>
          <DateTime
            useTime={false}
            value={dateFrom.value}
            componentId={`${id}_disabled_date_from_picker`}
            className="dateTime"
            parseDate={parseAsDateUTC}
            createDate={createUTCDate}
            cloneDate={dateToUTC}
            locale={locale}
            onChange={this.onChangeDateFrom}
            captionWrapper={'form'}
            {...createFormatters(locale)}
          />
        </div>
        <div>
          <label>{translation.filters_date_range_to}</label>
          <DateTime
            useTime={false}
            value={dateTo.value}
            componentId={`${id}_disabled_date_to_picker`}
            className="dateTime"
            parseDate={parseAsDateUTC}
            createDate={createUTCDate}
            cloneDate={dateToUTC}
            locale={locale}
            onChange={this.onChangeDateTo}
            captionWrapper={'form'}
            {...createFormatters(locale)}
          />
        </div>
      </div>
    </div>;
  }
}
